import React, { useEffect, useState } from "react";
import ApiService from "../services/ApiService";
import { toast } from "react-toastify";
import Footer from "../components/Footer/Footer";
import TopBar from "../components/TopBar";
import PageLoader from "../components/PageLoader";
import { Link } from "react-router-dom";

const Packages = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(false);

  const currency = process.env.REACT_APP_CURRENCY;

  const fetchPackages = async () => {
    try {
      setLoading(true);

      const response = await ApiService.get("/getAllPackages");
      const data = response.data;

      if (data && data.status === true) {
        setPackages(data.data);
      } else {
        toast.error(data.message || "Failed to fetch packages.");
      }
    } catch (error) {
      console.error("Error fetching packages:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPackages();
  }, []);

if (loading) {
  return (
    <PageLoader />
  );
}else{
  return (
    <div>
           
      <TopBar />

      <div className="container mt-5 allTestsHeading interview-txt">
        <div className="pkg-heading px-3 py-3 mb-2">
          <h3>Packages</h3>
        </div>
        <div className="row m-0 bg-white">
          
              {packages.map((packges, index) => (
                <div className="col-md-4 col-12 mb-4 "
                  key={index} >
                    
                  <div className="card h-100 shadow-sm rounded">
                    <div className="bg-base text-center p-3 text-white">
                        <h4 className="">{packges.name}</h4>
                    </div>
                    <div className="card-body">

                      <h5 className="text-center">{currency} {packges.price} / {packges.duration} {packges.duration_type}</h5>
                      <p className="">{packges.description}</p>

                      
                      {packges.user_packges ? (
                        <p className="badge bg-success">
                          {packges.user_packges.status}
                        </p>
                      ) : (
                        <Link to={'/checkout?package_id='+packges.id} className="btn btn-base w-100 p-3">Buy Now</Link>
                      )}
                    </div>
                  </div>
                </div>
              ))}
        </div>
        {packages.length === 0 && <div>No packages available.</div>}

      </div>
      <div className="pos-stick">
        <Footer />
      </div>
    </div>
  );
}
};

export default Packages;
